import { BlockConfig, zeroIOPS, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const loadBalancerConfig: BlockConfig = {
  displayName: "Application Load Balancer",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  hasSettings: true,
  allowedInputTypes: new Set([BlockTypes.USER, BlockTypes.AUTO_SCALING_GROUP, BlockTypes.APP_SERVER]),
  allowedOutputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LAMBDA,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: {
    total: 150000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 90000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 30000,
          [`${ContentTypes.STATIC}`]: 30000,
          [`${ContentTypes.STATIC_MEDIA}`]: 30000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 60000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 40000,
          [`${ContentTypes.STATIC_MEDIA}`]: 20000,
        },
      },
    },
  },
  processingCapacity: zeroIOPS(),
  purchasePrice: 50,
  sellPrice: 25,
  costPerCycle: 0.06,
  outputConnectorLimits: {},
};
